import requester, { IRequesterResponse } from '@/utils/requester';

const NoteServices = {
  async get(data: { uid?: string; limit?: number; offset?: number }, next?: string) {
    if (next) {
      const result: IRequesterResponse = await requester.get(next);
      return result;
    }

    const result: IRequesterResponse = await requester.get(next || '/phr/v1/notes', { params: data });
    return result;
  },

  async post(data: { uid: string; content: string }) {
    const result: IRequesterResponse = await requester.post('/phr/v1/notes', data);
    return result;
  },

  async patch(data: any) {
    const result: IRequesterResponse = await requester.patch('/phr/v1/notes', data);
    return result;
  },
};

export default NoteServices;
